module.exports = flarum.core.compat['helpers/highlight'];